<template lang="pug">
.appTutorialComponent
  .title Методическое сопровождение родителей учащихся начальной школы
  .slide
    .imageWrap
      img.img(:src="currentSlide.imgUrl")
      app-tutorial-box(
        v-for="(item, index) in currentSlide.content"
        :key="index"
        :item="item"
        :class="[`_id-${currentSlide.id}`, `_${index + 1}`]"
        @mouseenter="onMouseenter(item)"
        @mouseleave="onMouseleave(item)"
      )
    .content
      app-tutorial-paragraph(
        v-for="(item, index) in currentSlide.content"
        :key="index"
        :item="item"
        @mouseenter = "onMouseenter(item)"
        @mouseleave = "onMouseleave(item)"
      )

  .navbar
    .checkboxWrapper
      ui-checkbox.checkbox(
        v-if="showCheck"
        v-model="checked"
        label-classes="_blue"
        label-text="Больше не показывать"
      )
    .counter
      .text {{ currentSlideIndex + 1 }}/{{ slidesLength }}
    .buttons
      ui-button.button(
        v-show="currentSlideIndex !== 0"
        @click="onPrevSlideButtonClick"
        color="blue-outline"
      ) Назад
      ui-button.button(
        v-if="!isFinalSlide"
        @click="onNextSlideButtonClick"
      ) Далее
      ui-button.button(
        v-else
        @click="onAcceptButtonClick"
      ) Всё понятно
</template>

<script>
import { ref, inject, computed } from 'vue'
import slidesData from '@/mocks/tutorial.json'
import prodSlidesData from '@/mocks/tutorial-prod.json'
import AppTutorialBox from '@/components/AppTutorial/AppTutorialBox'
import AppTutorialParagraph from '@/components/AppTutorial/AppTutorialParagraph'

export default {
  name: 'AppTutorial',
  components: { AppTutorialParagraph, AppTutorialBox },
  inject: ['store'],
  emits: ['close', 'scroll-to-top'],
  setup (props, { emit }) {
    // modal block
    const store = inject('store')

    const isAuthenticated = computed(() => store.user.isAuthenticated)
    const showTutorial = computed(() => store.user.profile.showTutorial)
    const checked = ref(false)
    const showCheck = computed(() => isAuthenticated.value && showTutorial.value)

    // slider block
    const currentSlideIndex = ref(0)
    const currentSlide = computed(() => slides.value[currentSlideIndex.value])
    const slidesLength = computed(() => slides.value.length)
    const isFinalSlide = computed(() => currentSlideIndex.value + 1 === slidesLength.value)
    const slides = ref(process.env.NODE_ENV === 'production' ? prodSlidesData : slidesData)

    const onPrevSlideButtonClick = function () {
      emit('scroll-to-top')
      currentSlideIndex.value >= 1 && currentSlideIndex.value--
    }
    const onNextSlideButtonClick = function () {
      emit('scroll-to-top')
      currentSlideIndex.value + 2 <= slidesLength.value && currentSlideIndex.value++
    }
    const onMouseenter = function (item) {
      item.hover = true
    }
    const onMouseleave = function (item) {
      item.hover = false
    }

    const onAcceptButtonClick = function () {
      emit('close')
    }

    const onBeforeClose = async () => {
      if (checked.value && showTutorial.value) {
        await store.user.requestDenyTutorial()
      }
      return true
    }

    store.user.$on('denytotorial-success', () => {
      emit('close')
    })

    return {
      checked,
      showCheck,
      currentSlide,
      currentSlideIndex,
      slidesLength,
      isFinalSlide,
      onPrevSlideButtonClick,
      onNextSlideButtonClick,
      onAcceptButtonClick,
      onMouseenter,
      onMouseleave,
      onBeforeClose
    }
  }
}
</script>

<style lang="sass" scoped>
$navbarHeight: 13*$u

.appTutorialComponent
  user-select: none
  width: 250*$u
  max-width: 100%

  .title
    @include font('h2')
    margin-bottom: 6*$u
    padding-right: 10*$u

  .slide
    margin: 6*$u 0
    .imageWrap
      margin-bottom: 3*$u
      position: relative
      display: inline-block
      .img
        max-width: 100%
        max-height: 361px
    .content

  .navbar
    display: flex
    align-items: center
    justify-content: space-between
    margin-top: 6*$u
    height: $navbarHeight
    .checkboxWrapper
      display: flex
      align-items: center
      height: $navbarHeight
      width: 59*$u
      white-space: nowrap
      .checkbox
    .counter
      display: flex
      align-items: center
      height: $navbarHeight
      @include font('t18-regular')
      color: $cBlue
      user-select: none
    .buttons
      display: flex
      align-items: center
      justify-content: flex-end
      height: $navbarHeight
      width: 59*$u
      text-align: right
      .button
        &:first-child
          margin-right: 5*$u

  @media (max-width: $padWidth)
    .title
      @include font('m-h2')
    .navbar
      flex-direction: column
      height: auto
      .checkboxWrapper
        order: 9
        align-self: flex-start
        height: auto
        .checkbox
          margin-top: 5*$u
      .counter
        order: -1
      .buttons
        justify-content: space-between
        width: 100%
        margin-top: -$navbarHeight
        .button
          &:last-child
            margin-left: auto

  @media (max-width: $mobileWidth)
    .title
      @include font('m-t18-regular')
      font-weight: bold
</style>
